"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class ContainerHolder {
    static getInstance() {
        if (this.INSTANCE === null) {
            throw new exception_1.BadMethodCallException("ContainerHolder::getInstance, called before ContainerHolder::setInstance");
        }
        return ContainerHolder.INSTANCE;
    }
    static setInstance(c) {
        ContainerHolder.INSTANCE = c;
    }
}
ContainerHolder.INSTANCE = null;
exports.default = ContainerHolder;
//# sourceMappingURL=ContainerHolder.js.map